import { c as _c } from "react/compiler-runtime";
import { Block, BlockEnum } from "common/types/graphql";
import { BlocksRenderer } from "../BlocksRenderer";
import clsx from "classnames";
export interface ParagraphProps {
  blocks?: Block[];
  text?: string;
}
export const Paragraph = t0 => {
  "use memo";

  const $ = _c(10);
  const {
    blocks,
    text
  } = t0;
  let t1;
  let trimmedText;
  if ($[0] !== blocks || $[1] !== text) {
    trimmedText = text?.trim();
    const hasBlocks = blocks && blocks.length > 0 && blocks.some(_temp);
    const hasText = trimmedText && trimmedText.length > 0;
    t1 = clsx("max-w-(--breakpoint-lg) font-serif lg:text-xl", {
      "mb-4": hasBlocks || hasText
    });
    $[0] = blocks;
    $[1] = text;
    $[2] = t1;
    $[3] = trimmedText;
  } else {
    t1 = $[2];
    trimmedText = $[3];
  }
  let t2;
  if ($[4] !== blocks) {
    t2 = blocks && <BlocksRenderer blocks={blocks} />;
    $[4] = blocks;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== trimmedText) {
    t3 = <p className={t1}>{t2}{trimmedText}</p>;
    $[6] = t1;
    $[7] = t2;
    $[8] = trimmedText;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp(t0) {
  const {
    type,
    props
  } = t0;
  return type !== BlockEnum.Text || props.text?.trim()?.length > 0;
}